"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "lagundo": {
    "a53d59ac": [{
      "hkey": "5744f099",
      "slug": "centro-paese",
      "name": "Centro-Paese",
      "primary": true,
      "skipSearch": false
    }],
    "paese": [{
      "hkey": "5744f099",
      "slug": "centro-paese",
      "name": "Centro-Paese",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "53924bf2": [{
      "hkey": "d0d52950",
      "slug": "plars",
      "name": "Plars",
      "primary": true,
      "skipSearch": false
    }],
    "plars-di-mezzo": [{
      "hkey": "d0d52950",
      "slug": "plars",
      "name": "Plars",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "lagundo"
    }],
    "3ccda488": [{
      "hkey": "d0d52950",
      "slug": "plars",
      "name": "Plars",
      "primary": true,
      "skipSearch": false
    }],
    "plars-di-sopra": [{
      "hkey": "d0d52950",
      "slug": "plars",
      "name": "Plars",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "44780864": [{
      "hkey": "cb65d55b",
      "slug": "rio-lagundo",
      "name": "Rio Lagundo",
      "primary": true,
      "skipSearch": false
    }],
    "rioalgundo": [{
      "hkey": "cb65d55b",
      "slug": "rio-lagundo",
      "name": "Rio Lagundo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "f29ffb1d": [{
      "hkey": "4dacc221",
      "slug": "lagundo",
      "name": "Lagundo",
      "primary": true,
      "skipSearch": false
    }],
    "riomolino": [{
      "hkey": "4dacc221",
      "slug": "lagundo",
      "name": "Lagundo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;